import { ReactNode } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';

// -- ConversationEndMessage ----------------------------------------------------
// The completion message shown when a conversation ends, shared between the
// student runtime and the admin previews so the wording and styling can't drift.
// The action below it (continue, replay) is the caller's concern, passed in.
export function ConversationEndMessage({ action }: { action?: ReactNode }) {
  return (
    <Flex alignItems="center" flexDirection="column" w="100%" mt="3">
      <Text fontSize="xs" color="fg.muted" fontWeight="medium" textAlign="center">
        <Trans>
          You have successfully completed the learning material for this section of this unit.
        </Trans>
      </Text>
      {action}
    </Flex>
  );
}
